"use client";

import { Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { initPostHog, posthog } from "@/lib/posthog";
import { ConsentBanner } from "./ConsentBanner";

function PostHogPageviewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Initialize PostHog once (idempotent — safe to call multiple times)
  useEffect(() => {
    initPostHog();
  }, []);

  // Track pageviews on route change. No ready-gate: the façade queues
  // pre-init calls, so the FIRST pageview of a cold load (fired while
  // posthog-js is still lazy-importing) is delivered instead of dropped —
  // entry pages were systematically undercounted before this.
  useEffect(() => {
    posthog.capture("$pageview");
  }, [pathname, searchParams]);

  return null;
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Suspense fallback={null}>
        <PostHogPageviewTracker />
      </Suspense>
      {children}
      <ConsentBanner />
    </>
  );
}
